import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import { IconButton } from "@mui/material";

interface Props {
  onClick: () => void;
  disabled: boolean;
}

export const EmptyWeightCell = ({ onClick, disabled }: Props) => {
  const handleOnClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onClick();
  };

  if (disabled) {
    return null;
  }

  return (
    <IconButton sx={{ padding: 0 }} onClick={handleOnClick}>
      <AddCircleOutlineIcon fontSize="small" />
    </IconButton>
  );
};
